import React from 'react';
import styles from './Footer.module.css';
import { FaInstagram, FaXTwitter, FaLinkedin, FaFacebook } from 'react-icons/fa6';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.socialIcons}>
        <a href="https://www.instagram.com/tailoredapproachus/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://x.com/TApproachUS" target="_blank" rel="noopener noreferrer">
          <FaXTwitter />
        </a>
        <a href="https://linkedin.com/company/t-approach/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61572238018189" target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </a>
      </div>

      <div className={styles.copyText}>
        © 2025 Tailored Approach LLC. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
